export default __webpack_public_path__ + "static/media/SIW400G_K015_20_25_30_37_W00.dfadfaa4.webp";